<p>membership-redirection works!</p>
<div class="banner__tag">{{pom}}</div>